import { useState } from 'react';
import { Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils } from '@fortawesome/free-solid-svg-icons';

import config from '../../../config';
import MealItem from './MealItem';

import './MealSelector.less';

const MealSelector = ({ selectedMeal: initialSelected, onContinue, meals = [], loading = false, onSelectMeal }) => {
	const [selectedMeal, setSelectedMeal] = useState(initialSelected);

	useState(() => {
		if (initialSelected && initialSelected?.meal_id)
			setSelectedMeal(initialSelected.meal_id);
	}, []);

	const handleMealClick = (meal) => {
		if (meal.isFull) {
			return;
		}

		setSelectedMeal(meal.meal_id);

		if (onSelectMeal) {
			onSelectMeal(meal.meal_id);
		}
	};

	const handleContinue = () => {
		if (!selectedMeal) {
			return;
		}
		const selected = meals.find(m => m.meal_id === selectedMeal);

		onContinue(selected);
	};

	if (loading) {
		return (
			<div className="meal-selector">
				<div className="meal-loading">
					<Spin size="large" />
					<p>Loading available meals...</p>
				</div>
			</div>
		);
	}

	if (meals.length === 0) {
		return (
			<div className="meal-selector">
				<div className="meal-header">
					<FontAwesomeIcon
						icon={faUtensils}
						className="meal-icon"
					/>
					<h2 className="meal-title">選擇餐點 Select Your Meal</h2>
					<p className="meal-subtitle">今日所有餐點已售罄。No meals available today.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="meal-selector">
			<div className="meal-header">
				<FontAwesomeIcon
					icon={faUtensils}
					className="meal-icon"
				/>
				<h2 className="meal-title">選擇餐點 Select Your Meal</h2>
				{/* <p className="meal-subtitle">Delicious options await</p> */}
			</div>

			<div className="meal-list">
				{meals.map((meal) => {
					// Construct image URL like in grb-meal-admin
					let imageUrl = null;
					if (meal.asset && meal.asset.uuid && meal.asset.token) {
						imageUrl = `${config.api}/app/assets/id?uuid=${meal.asset.uuid}&token=${meal.asset.token}`;
					}

					return (
						<MealItem
							key={meal.meal_id}
							meal={{
								_id: meal.meal_id,
								name: meal.meal_name,
								description: meal.meal_description,
								price: meal.meal_price,
								image: imageUrl,
								soldOut: meal.isFull
							}}
							isSelected={selectedMeal === meal.meal_id}
							onClick={() => handleMealClick(meal)}
						/>
					);
				})}
			</div>

			<div className="meal-footer">
				<button
					className="meal-continue-btn"
					onClick={handleContinue}
					disabled={!selectedMeal}
				>
					下一步 Continue
				</button>
			</div>
		</div>
	);
};

export default MealSelector;
